























































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import FiltersLunch from './FiltersLunchControl.vue'

// services
import { LunchControlsService } from '@/services/dailyControl'

// Models
import { Paginator } from '@/models'
import { FiltersLunchControl, LunchControlModel } from '@/models/dailyControl'

@Component({
    name: 'TableListLunchControls',
    components: {
        DataTable,
        FiltersLunch
    }
})
export default class TableListLunchControls extends Vue {
    @Prop({ required: true, type: Object }) filters!: FiltersLunchControl

    loading = false
    items: [LunchControlModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'employee.name',
            sortable: true,
            label: 'Empleado'
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha'
        },
        {
            key: 'lunchRate.name',
            sortable: true,
            label: 'Tarifa'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '10%'
            }
        }
    ]

    created () {
        this.getLunchControlsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getLunchControlsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getLunchControlsWithPagination()
    }

    getByFilters () {
        this.pagination.currentPage = 1
        this.getLunchControlsWithPagination()
    }

    clearFilters () {
        this.pagination.currentPage = 1
        this.filters.dateStart = null
        this.filters.dateEnd = null
        this.filters.employee = null
        this.getLunchControlsWithPagination()
    }

    async getLunchControlsWithPagination () {
        this.loading = true
        const response = await LunchControlsService.getWithPagination(this.pagination.perPage, this.pagination.currentPage, this.filters)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
